module.exports = __webpack_public_path__ + "img/latest_books_default.c38910f1.png";